@if(!isTwoQuestionsFormat){
  <div class="container">
    @if(currentStep <= steps){
      <div class="container-md survey" >
        <!-- SURVEY QUESTIONS -->
        <div class="u-flex u-flex-column u-flex-justify-content-between survey-skin">
          <!-- SURVEY PROGRESS BAR -->
          <div class="progress-bar">
            <div class="progress-bar-progress" [ngStyle]="{ width: ((currentStep || 0) * 100) / (steps || 1) + '%' }"></div>
          </div>
          <div>
            <!-- SURVEY STEPS -->
            <div class="survey-steps">
              <i class="icon-navigate_before" [ngClass]="{ 'step-move-disabled': currentStep === 1 }"
                (click)="previousQuestion()"></i>
              <div class="step-text">
                <span class="current-step">{{ currentStep }}</span>
                {{ "SURVEY.OF" | translate }} {{ steps }}
              </div>
              <!-- '.step-move-disabled' class for grey disable style -->
              <i class="icon-navigate_next" [ngClass]="{ 'step-move-disabled': !canPassToNextQuestion }"
                (click)="nextQuestion($event)"></i>
            </div>
            <!-- SURVEY QUESTIONS -->
            <div class="survey-q">
              {{ questionList[currentStep - 1].text }}
            </div>
          </div>
          <!-- SURVEY ANSWERS -->
          <div class="survey-a">
            <form action="">
              @if(questionList[currentStep - 1].type === inputType.BOOLEAN.name){
               
                <!-- TWO BUTTONS -->
                <div class="answer-buttons" >
                  <div class="form-block">
                    <div id="survey-button-ok">
                      <!-- AÑADIR CLASE .selected-answer-btn SI ES LA OPCIÓN SELECCIONADA -->
                      <button [ngClass]="{
                          'selected-answer-btn': questionList[currentStep - 1].value
                        }" class="btn btn-primary btn-lg" type="submit" (click)="setAnswer(true)">
                        {{ "SURVEY.YES" | translate }}
                      </button>
                    </div>
                    <div id="survey-button-ko">
                      <!-- AÑADIR CLASE .selected-answer-btn SI ES LA OPCIÓN SELECCIONADA -->
                      <button [ngClass]="{
                          'selected-answer-btn':
                            questionList[currentStep - 1].value === false
                        }" class="btn btn-primary btn-lg" type="submit" (click)="setAnswer(false)">
                        {{ "SURVEY.NO" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              }
    
              @if(questionList[currentStep - 1].style === inputType.RATING.styles.emojis){

                <!-- EMOJI BUTTONS -->
                <div class="emoji-buttons">
                  <div class="form-block">
                    @for(emoji of questionList[currentStep - 1].emoji; track $index; let i = $index){

                      <div class="fancy-check-button">
                        <input type="radio" name="status" id="{{ i }}" [value]="questionList[currentStep - 1].value"
                          (click)="setAnswer(i + 1)" />
                        <div class="fancy-check-mark">
                          <i [ngClass]="
                              questionList[currentStep - 1].emojiSelected === i + 1
                                ? emoji.iconOn
                                : emoji.icon
                            "></i>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
    
              @if(questionList[currentStep - 1].type === inputType.INPUT.name){
              
                <!-- TEXTAREA -->
                <div class="answer-textarea">
                  <textarea name="textarea" rows="5" cols="50" placeholder="{{ 'SURVEY.INPUT_TEXT_PLACEHOLDER' | translate }}"
                    [maxlength]="maxLengthTextArea" [value]="questionList[currentStep - 1].value" [(ngModel)]="textAreaModel"
                    class="u-divider-top-xxl"></textarea>
                  <div id="survey-button-ok" class="u-flex u-flex-justify-content-center u-divider-top-xxl">
                    <button [ngStyle]="{
                        visibility:
                          (textAreaModel?.length || 0) < minLengthTextArea
                            ? 'hidden'
                            : 'visible'
                      }" class="btn btn-primary btn-lg" type="submit" (click)="setAnswer(textAreaModel)">
                      {{ "SURVEY.ACCEPT" | translate }}
                    </button>
                  </div>
                </div>
              }
    
              @if(questionList[currentStep - 1].type === inputType.RATING.name &&
                  (questionList[currentStep - 1].style ===
                    this.inputType.RATING.styles.slider ||
                    questionList[currentStep - 1].style ===
                      this.inputType.RATING.styles.stars ||
                    questionList[currentStep - 1].style ===
                      this.inputType.RATING.styles.starts)){
                        <div class="rating-container">
                          <div class="rating u-divider-top-xl">
                            <label>
                              <input type="radio" name="stars" value="1" [checked]="questionList[currentStep - 1].value === 1"
                                (click)="setAnswer(1)" />
                              <i class="icon icon-star-off"></i>
                            </label>
                            <label>
                              <input type="radio" name="stars" value="2" [checked]="questionList[currentStep - 1].value === 2"
                                (click)="setAnswer(2)" />
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                            </label>
                            <label>
                              <input type="radio" name="stars" value="3" [checked]="questionList[currentStep - 1].value === 3"
                                (click)="setAnswer(3)" />
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                            </label>
                            <label>
                              <input type="radio" name="stars" value="4" [checked]="questionList[currentStep - 1].value === 4"
                                (click)="setAnswer(4)" />
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                            </label>
                            <label>
                              <input type="radio" name="stars" value="5" [checked]="questionList[currentStep - 1].value === 5"
                                (click)="setAnswer(5)" />
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                              <i class="icon icon-star-off"></i>
                            </label>
                          </div>
                        </div>
              }
              <!-- RATING STARS CONTAINER -->
            </form>
          </div>
        </div>
      </div>
    }
    @if(currentStep > steps){     
      <div class="container-md survey-list-container">
        <!-- SURVEY ANSWER LIST -->
        <div class="survey-review">
          <ul class="survey-review-list u-scrollbar-y">
            @for(answer of questionList; track $index){
              <li class="survey-review-item">
                <div class="survey-review-q">{{ answer.text }}</div>
                <div class="survey-review-a">
                  @if(answer.type === inputType.BOOLEAN.name){
                    <div>
                      {{ answer.value ? "Sí" : "No" }}
                    </div>
                  }
                  @if(answer.type === inputType.RATING.name){
                    <div>
                      {{ answer.value }}
                      <!-- <i [ngClass]="'icon-emoji-' + answer.value.toString()"></i> -->
                    </div>
                  }
                  @if (answer.type === inputType.INPUT.name) {
                    <div style="font-size: 15px">
                      {{ charsLimitation(answer.value) }}
                    </div>
                  }
            
                </div>
              </li>
            }
          </ul>
          <div class="button-container u-divider-top-xxl u-flex u-flex-justify-content-between u-divider-bottom-sm">
            <button class="btn btn-primary outline btn-lg u-divider-top-xxl" type="submit" (click)="back()">
              {{ "SURVEY.BACK" | translate }}
            </button>
            <button class="btn btn-primary btn-lg u-divider-top-xxl" type="submit" (click)="sendSurvey()">
              {{ "SURVEY.SEND" | translate }}
            </button>
          </div>
        </div>
      </div>
    }
  </div>
}

@if(isTwoQuestionsFormat && questionList.length >= 2){
  <div class="container">
    <div class="container-md survey">
      <!-- SURVEY QUESTIONS -->
      <div class="u-flex u-flex-column u-flex-justify-content-between survey-skin">
        <!-- SURVEY PROGRESS BAR -->
        <div class="progress-bar">
          <div class="progress-bar-progress"></div>
        </div>

        <!-- SURVEY ANSWERS -->
        <div class="survey-a">
          <form action="">
            @if(questionList[0].type === inputType.RATING.name &&
                (questionList[0].style === this.inputType.RATING.styles.slider ||
                  questionList[0].style === this.inputType.RATING.styles.stars ||
                  questionList[0].style === this.inputType.RATING.styles.starts)){
                    <div class="rating-container" >
                      <div class="range-text">
                        {{ questionList[0].text }}
                      </div>
                      <div class="rating u-divider-top-xl">
                        <label>
                          <input type="radio" name="stars" value="1" [checked]="questionList[0].value === 1"
                            (click)="setAnswer(1)" />
                          <i class="icon icon-star-off"></i>
                        </label>
                        <label>
                          <input type="radio" name="stars" value="2" [checked]="questionList[0].value === 2"
                            (click)="setAnswer(2)" />
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                        </label>
                        <label>
                          <input type="radio" name="stars" value="3" [checked]="questionList[0].value === 3"
                            (click)="setAnswer(3)" />
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                        </label>
                        <label>
                          <input type="radio" name="stars" value="4" [checked]="questionList[0].value === 4"
                            (click)="setAnswer(4)" />
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                        </label>
                        <label>
                          <input type="radio" name="stars" value="5" [checked]="questionList[0].value === 5"
                            (click)="setAnswer(5)" />
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                          <i class="icon icon-star-off"></i>
                        </label>
                      </div>
                    </div>
            }
            <!-- RATING STARS CONTAINER -->

            <!-- SELECT -->
            @if(questionList[1].type === inputType.GROUP.name &&
                questionList[0].value &&
                questionList[0].value < 4){

                  <div class="" >
                    <div class="u-divider-top-xxl">
                      {{ questionList[1].text }}
                    </div>
                    <div class="form-group">
                      <select name="select-response" class="form-control col-12" (change)="onChange($event.target)">
                        <option [value]="null" selected disabled>
                          Seleccionar uno.
                        </option>
                        @for (option of questionList[1].childs; track option.id) {
                          <option [value]="option.id">
                            {{ option.text }}
                          </option>
                        }
                      </select>
                    </div>

                    @if(selectResponse === questionList[1].childs[questionList[1].childs.length - 1].id){
                    <!-- TEXTAREA -->
                    <div class="answer-textarea u-divider-top-xxl">
                      <textarea name="textarea" rows="5" cols="50"
                        placeholder="{{ 'SURVEY.INPUT_TEXT_PLACEHOLDER' | translate }}" [maxlength]="maxLengthTextArea"
                        [(ngModel)]="textAreaModel" (ngModelChange)="isButtonVisible()"></textarea>
                    </div>
                    }
                  </div>
                }

            <!-- TERCERA PREGUNTA: ¿Recomendaría este tipo de visita? (Solo PATIENT) -->
            @if(questionList[2] && questionList[2].type === inputType.GROUP.name){
              <div class="u-divider-top-xxl">
                <div class="recommend-question-text">
                  {{ questionList[2].text }}
                </div>
                <div class="recommend-options u-divider-top-lg">
                  @for (option of questionList[2].childs; track option.id) {
                    <label class="recommend-radio-label">
                      <input
                        type="radio"
                        name="recommend"
                        [value]="option.id"
                        [checked]="selectedRecommendOption === option.id"
                        (change)="onRecommendChange(option)" />
                      <span class="recommend-radio-text">{{ option.text }}</span>
                    </label>
                  }
                </div>
              </div>
            }


            @let buttonVisibleRef = buttonVisible$ | async;
            @if(buttonVisibleRef){
              <div id="survey-button-ok" class="u-flex u-flex-justify-content-center u-divider-top-xxl u-divider-bottom-xxl"
                [ngStyle]="{
                  visibility:
                    !(buttonVisibleRef)
                      ? 'hidden'
                      : 'visible'
                }">
                <button class="btn btn-primary btn-lg" type="submit" (click)="sendSurvey()">
                  {{ "SURVEY.ACCEPT" | translate }}
                </button>
              </div>
            }
          </form>
        </div>
      </div>
    </div>
    <!-- SIN PATALLA RESUMEN -->
  </div>
}

@if(loading){
  <div class="survey-loading">
    <div class="survey-loading-img">
      <img [src]="'assets/spinner.svg'">
    </div>
  </div>
}